// const createReturnCar = () => import('@/pages/returnCar/createReturnCar')
const returnCarList = () => import('@/pages/replaceCar/returnCarList')
const returnCarListItem = () => import('@/pages/replaceCar/returnCarListItem')
// const returnCar = () => import('@/pages/returnCar')
const newReturnCar = () => import('@/pages/newReturnCar')
const createNewReturnCar = () => import('@/pages/newReturnCar/createReturnCar')
const createPaperlessNewReturnCar = () => import('@/pages/newReturnCar/createPaperlessReturnCar')
const NewFixedLoss = () => import('@/pages/newReturnCar/NewFixedLoss')
const createForcedNewReturnCar = () => import('@/pages/newReturnCar/createForcedReturnCar')
// 重构旧的退车工单
const newReturnCarCopy = () => import('@/pages/newReturnCar_copy/index')
const createNewReturnCarCopy = () => import('@/pages/newReturnCar_copy/createReturnCar')
const createPaperlessReturnCar_copy = () => import('@/pages/newReturnCar_copy/createPaperlessReturnCar')
const returnCarList_copy = () => import('@/pages/newReturnCar_copy/returnCarList')
const returnCarListItem_copy = () => import('@/pages/newReturnCar_copy/returnCarListItem')
// const createForcedReturnCar = () => import('@/pages/newReturnCar_copy/createForcedReturnCar')

export default [
  // 新退车工单
  {
    path: '/newReturnCar',
    name: 'newReturnCar',
    component: newReturnCar,
    meta: {
      storeKey: 'trs.newReturnCar.index'
    }
  },
  {
    path: '/createNewReturnCar',
    name: 'createNewReturnCar',
    component: createNewReturnCar,
    meta: {}
  },
  {
    path: '/createPaperlessNewReturnCar',
    name: 'createPaperlessNewReturnCar',
    component: createPaperlessNewReturnCar,
    meta: {}
  },
  {
    path: '/addDetermination',
    name: 'addDetermination',
    component: NewFixedLoss,
    meta: {}
  },
  {
    path: '/createForcedNewReturnCar',
    name: 'createForcedNewReturnCar',
    component: createForcedNewReturnCar,
    meta: {}
  },
  // 重构旧的退车工单
  {
    path: '/returnCar',
    name: 'returnCar',
    component: newReturnCarCopy,
    meta: {
      storeKey: 'trs.returnCar.index'
    }
  },
  {
    path: '/createReturnCar',
    name: 'createReturnCar',
    component: createNewReturnCarCopy,
    meta: {}
  },
  // {
  //   path: '/createForcedReturnCar',
  //   name: 'createForcedReturnCar',
  //   component: createForcedReturnCar
  // },
  {
    path: '/returnCarListItem_copy',
    name: 'returnCarListItem_copy',
    component: returnCarListItem_copy,
    meta: {}
  },
  {
    path: '/returnCarList_copy',
    name: 'returnCarList_copy',
    component: returnCarList_copy,
    meta: {}
  },
  {
    path: '/returnCarListItem',
    name: 'returnCarListItem',
    component: returnCarListItem,
    meta: {}
  },
  {
    path: '/returnCarList',
    name: 'returnCarList',
    component: returnCarList,
    meta: {}
  },
  {
    path: '/createPaperlessReturnCar',
    name: 'createPaperlessReturnCar',
    component: createPaperlessReturnCar_copy,
    meta: {}
  }
]



// WEBPACK FOOTER //
// ./src/router/returnCar/index.js